import { Moment } from 'moment';

import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatInput } from '@angular/material/input';

import { SLIDE_RIGHT } from '@bp/shared/animations';
import { DatepickerCalendarHeaderComponent, FormFieldControlComponent } from '@bp/shared/components/core';

@Component({
	selector: 'bp-datepicker',
	templateUrl: './datepicker.component.html',
	styleUrls: [ './datepicker.component.scss' ],
	animations: [ SLIDE_RIGHT ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'(focusin)': 'onTouched();',
	},
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: DatePickerComponent,
			multi: true,
		},
		{
			provide: NG_VALIDATORS,
			useExisting: DatePickerComponent,
			multi: true,
		},
	],
})
export class DatePickerComponent extends FormFieldControlComponent<Moment | null> {

	/** The minimum valid date. */
	@Input() min?: Moment;

	 /** The maximum valid date. */
	@Input() max?: Moment;

	/** The date to open the calendar to initially. */
	@Input() startAt?: Moment;

	@Input() startView?: 'month' | 'multi-year' | 'year';

	@ViewChild(MatInput, { static: true }) input!: MatInput;

	// eslint-disable-next-line @typescript-eslint/naming-convention
	DatepickerCalendarHeaderComponent = DatepickerCalendarHeaderComponent;

	set(v?: Moment | null) {
		if (v && this.value && v.isSame(this.value) || v !== this.value)
			this.setValue(v ?? null);
	}

	focus(): void {
		this.input.focus();
	}
}
